import * as actions from "../../actions/pieceTagReport";

const initialState = {
	items: [],
	loading: false,
	pages: 0,
	count: 0,
	filter: []
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.SET_VALUE: {
			return {
				...state,
				...payload
			};
		}
		case actions.CLEAR_VALUE: {
			return {
				...state,
				...initialState
			};
		}
		case actions.GET_PIECE_TAGS: {
			return {
				...state,
				loading: true
			};
		}
		case actions.GET_PIECE_TAGS_FAILED: {
			return {
				...state,
				loading: false
			};
		}
		case actions.GET_PIECE_TAGS_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: false
			};
		}
		default: {
			return state;
		}
	}
};

export default reducer;
